import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Breadcrumbs, InputAdornment, Link, Tab, Tabs, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const corPrimaria = "#0b243d";

// As rotas devolvem os campos do model em minúsculas (nome, email...); versões antigas usavam
// maiúsculas (Nome, Email...). Aceita as duas formas.
export const campo = (usuario, nome) => usuario?.[nome] ?? usuario?.[nome.charAt(0).toUpperCase() + nome.slice(1)] ?? "";

export const normalizar = (texto) => String(texto || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
export const somenteDigitos = (texto) => String(texto || "").replace(/\D/g, "");
export const iniciais = (nome) => String(nome || "?").trim().split(/\s+/).slice(0, 2).map((parte) => parte[0]?.toUpperCase()).join("");

// Busca por nome/e-mail (sem acento) e por CPF/telefone (só dígitos)
export const filtrarUsuarios = (usuarios, busca) => {
    const termo = normalizar(busca.trim());
    const digitos = somenteDigitos(busca);
    if (!termo) return usuarios;
    return usuarios.filter((usuario) =>
        ["nome", "email"].some((c) => normalizar(campo(usuario, c)).includes(termo))
        || (digitos.length > 0 && ["cpf", "telefone", "idUsuario"].some((c) => somenteDigitos(campo(usuario, c)).includes(digitos)))
    );
};

const abas = [
    { label: "Clientes", caminho: "/Usuarios" },
    { label: "Administradores", caminho: "/Admins" },
];

// Cabeçalho comum às páginas de usuários: breadcrumb, título, ações e abas Clientes/Administradores
export function CabecalhoUsuarios({ titulo, descricao, acoes }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const abaAtual = abas.findIndex((aba) => aba.caminho === pathname);

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/Dashboard">
                    Dashboard
                </Link>
                <Typography sx={{ color: 'text.primary' }}>Usuários</Typography>
            </Breadcrumbs>

            <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 2 }}>
                <Box>
                    <Typography sx={{ fontSize: 24, fontWeight: 600 }}>{titulo}</Typography>
                    <Typography variant="body2" color="text.secondary">{descricao}</Typography>
                </Box>
                {acoes}
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2, mb: 3 }}>
                <Tabs
                    value={abaAtual === -1 ? false : abaAtual}
                    onChange={(e, indice) => navigate(abas[indice].caminho)}
                    sx={{ "& .MuiTab-root": { textTransform: "none" }, "& .Mui-selected": { color: `${corPrimaria} !important` }, "& .MuiTabs-indicator": { backgroundColor: corPrimaria } }}
                >
                    {abas.map((aba) => <Tab key={aba.caminho} label={aba.label} />)}
                </Tabs>
            </Box>
        </>
    );
}

export function CampoBusca({ valor, onChange, placeholder }) {
    return (
        <TextField
            fullWidth
            size="small"
            placeholder={placeholder}
            value={valor}
            onChange={(e) => onChange(e.target.value)}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
}
